import { Map as IMap } from 'immutable';
import { createSelector } from 'reselect';
import {
    getCapiSessionID,
    getCapiUrl,
    getCapiToken
} from 'capi/redux/immutable';
import { createCapiClient } from 'capi';

import { getIovation } from '../iovation/iovationModule';
import { getSsoSid } from '../auth/authSelectors';

export const getCapiClient = createSelector(
    getCapiSessionID, getCapiUrl, getCapiToken, getIovation,
    (sessionID, capiUrl, capiToken, iovation) => (
        createCapiClient(
            capiUrl,
            capiToken,
            sessionID,
            iovation.get('blackbox'),
            iovation.get('blackboxUrl'),
            'sfv2'
        )
    )
);

export const getAuthAwareCapiClient = createSelector(
    getSsoSid,
    getCapiSessionID, getCapiUrl, getCapiToken, getIovation,
    (ssoSid, sessionID, capiUrl, capiToken, iovation) => {
        const client = createCapiClient(
            capiUrl,
            capiToken,
            sessionID,
            iovation.get('blackbox'),
            iovation.get('blackboxUrl'),
            'sfv2'
        );
        if (ssoSid) {
            
            client.defaults.headers.common['X-Storefront-Sid'] = ssoSid;
        }
        return client;
    }
);

export const getStorefrontSession = state => state.get('session', IMap());

export const getStorefrontSessionKey = createSelector(
    getStorefrontSession,
    session => session.get('sessionKey')
);

export const getIsGridViewHomePage = state => state.get('isGridViewHomePage', IMap());

export const getIsGridViewHomePageEnabled = createSelector(
    getIsGridViewHomePage,
    gridViewFlag => gridViewFlag.get('isGridViewHomePageFlag')
);
export const getCapiCall = state => state.get('capiCall', IMap());

export const getCapiSessionCallIndicator = createSelector(
    getCapiCall,
    session => session.get('sessionCallInProgress')
);
